var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stampa"}},[_c('el-row',{staticClass:"titolo",attrs:{"span":24}},[_c('h3',[_vm._v("STAMPA")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }